'use client'

import { useUAContext } from '@/context/UAContext'
import { useScrollOverflowMask } from '@/hooks/useScrollOverflowMask'
import { cn } from '@/lib/utils'
import { motion, useScroll } from 'framer-motion'
import { PropsWithChildren, useRef } from 'react'

export default function RecommendWorldsWrapper({ children }: PropsWithChildren) {
  const { isMobile } = useUAContext()
  const ref = useRef(null)
  const { scrollXProgress } = useScroll({ container: ref })
  const maskImage = useScrollOverflowMask({ scrollXProgress })

  return (
    <motion.div
      ref={ref}
      style={{ maskImage: isMobile ? maskImage : 'none' }}
      className="no-scrollbar g:col-start-2 flex flex-col max-lg:overflow-scroll max-lg:scroll-smooth lg:row-span-2"
    >
      <div
        className={cn('flex gap-4', {
          'md:grid md:grid-cols-3 md:gap-6 md:gap-y-8 lg:flex lg:flex-col lg:gap-8': !isMobile,
        })}
      >
        {children}
      </div>
    </motion.div>
  )
}
